import {
    defineMessages,
} from 'react-intl'

const messages = defineMessages({
    "most_used_filters": {
        id: "invoice.listing.headers.most_used_filters",
        defaultMessage: "Most used filters",
    },
    "status": {
        id: "invoice.listing.headers.status_label",
        defaultMessage: "Status",
    },
    "status_filter_placeholder": {
        id: 'invoice.listing.status_filter_placeholder',
        defaultMessage: 'Filter by status',
    },
    "sellerId": {
        id: "invoice.listing.headers.seller_id",
        defaultMessage: "User id",
    },
    "title": {
        id: "scheduling_page.events.listing.headers.title_label",
        defaultMessage: "Title",
    },
    "location": {
        id: "invoice.listing.headers.location",
        defaultMessage: "Location",
    },
    "identifier": {
        id: "invoice.listing.headers.id_label",
        defaultMessage: 'ID'
    },
    "calendar": {
        id: "common.scheduling_page.modal.calendar_label",
        defaultMessage: 'Calendar'
    },
    "created_at": {
        id: 'invoice.listing.filters.date.created_at',
        defaultMessage: 'Created date',
    }, 
    "activated_at": {
        id: "pricing_list.listing.headers.activated_at",
        defaultMessage: "Activated at",
    },
    "date_related_filters": {
        id: "invoice.listing.headers.date_related_filters",
        defaultMessage: "Date related filters",
    },
    "other_filters": {
        id: "invoice.listing.headers.other_filters",
        defaultMessage: "Other filters",
    },
})

export const schedulingListTotals = []

export const schedulingFields = [
    'identifier',
    'title',
    'titleKeyword',
    'titleAnalyzed',
]

export const getSchedulingFilters = function (context) {
    var filtersToUse =
        [
            {
                section: context.intl.formatMessage(messages["most_used_filters"]),
            },
            {
                nameId: 'userId',
                label: context.intl.formatMessage(messages["sellerId"]),
                filterMatch: 'sellerId',
                type: 'select',
                typeOfSelect: 'user-select',
                placeHolder: 'Select User',
                initialValue: '',
                initialSelect: 'isOneOf'
            },
            {
                nameId: 'locationId',
                label: context.intl.formatMessage(messages["location"]),
                filterMatch: 'locationId',
                type: 'select',
                typeOfSelect: 'location-select',
                placeHolder: 'Select Location',
                initialValue: [],
                initialSelect: 'isOneOf'
            },
            {
                nameId: "title",
                label: context.intl.formatMessage(messages["title"]),
                filterMatch: 'titleKeyword',
                type: 'text',
                initialValue: '',
                initialSelect: 'is'
            },
            {
                nameId: 'statuses',
                label: context.intl.formatMessage(messages["status"]),
                type: 'select',
                filterMatch: 'status',
                typeOfSelect: 'scheduling-page-status-select',
                placeHolder: context.intl.formatMessage(messages["status_filter_placeholder"]),
                initialValue: [],
                initialSelect: 'isOneOf'
            },
            {
                nameId: 'calendarId',
                label: context.intl.formatMessage(messages["calendar"]),
                filterMatch: 'calendarIds',
                type: 'select',
                typeOfSelect: 'calendar-select',
                placeHolder: 'Select Calendar',
                initialValue: '',
                initialSelect: 'isOneOf'
            },
            {
                section: context.intl.formatMessage(messages["date_related_filters"]),
            },
            {
                nameId: 'createdAt',
                label: context.intl.formatMessage(messages["created_at"]),
                filterMatch: 'createdAt',
                type: 'date',
                initialValue: { startDate: null, endDate: null },
                initialSelect: 'is'
            },
            {
                nameId: 'activatedAt',
                label: context.intl.formatMessage(messages["activated_at"]),
                filterMatch: 'activatedAt',
                type: 'date',
                initialValue: { startDate: null, endDate: null },
                initialSelect: 'is'
            },
            {
                section: context.intl.formatMessage(messages["other_filters"]),
            },
            {
                nameId: "identifier",
                label: context.intl.formatMessage(messages["identifier"]),
                filterMatch: 'identifier',
                type: 'text',
                initialValue: '',
                initialSelect: 'is'
            },
        ]

    return filtersToUse
}


// WEBPACK FOOTER //
// ./src/common/search-filter/search/schedulingFilters.jsx